import get from '../../utils/get';

const SORT_ASC = 'ASC';

export default function dataSorter(data, sortBy, sortDirection, sortColumn) {
  const sorted = data.map((datum, index) => index);
  const cellSorter = sortColumn?.props?.cellSorter;

  if (sortBy) {
    sorted.sort((a, b) => {
      const v1 = getSortedDataForRow(data[a], sortBy, cellSorter);
      const v2 = getSortedDataForRow(data[b], sortBy, cellSorter);
      if ((v1 === undefined || v1 === null) && (v2 === undefined || v2 === null)) {
        return 0;
      }
      if (v1 === undefined || v1 === null || v1 < v2) {
        return sortDirection === SORT_ASC ? -1 : 1;
      } else if (v2 === undefined || v2 === null || v1 > v2) {
        return sortDirection === SORT_ASC ? 1 : -1;
      }
      return 0;
    });
  }

  return sorted;
}

function getSortedDataForRow(rowData, sortBy, cellSorter) {
  return cellSorter ? cellSorter({cellData: get(rowData, sortBy), dataKey: sortBy, rowData}) : get(rowData, sortBy);
}
